import * as Sentry from '@sentry/react';
import { loadStripe } from '@stripe/stripe-js';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { createPortal } from 'react-dom';
import { withTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import { PulseLoader } from 'react-spinners';
import i18n from '../../../lib/i18n/index.js';
import CardConnectAdapter from '../../../providers/cardconnect/adapter.js';
import StripeAdapter, {
  confirmPayment,
  confirmSetup,
  createConfirmationToken,
  createPaymentMethod,
} from '../../../providers/stripe/adapter.jsx';
import { surchargeQuote } from '../../../util/appointment_api_util';
import $$ from '../../../util/$$';
import { getFullLanguageName } from '../../../util/languageUtils.js';
import FlexIcon from '../../styles/flex_icon';
import {
  BackButton,
  SelectButton as Button,
  ScheduleButton as ContinueButton,
  Spacer,
} from '../../styles/styledComponents';
import { getContrast } from '../../styles/contrast';
import Disclaimer from './disclaimer';
import GuarantorModal from './guarantorModal';
import DropdownQuestion from './inputs/dropdown';
import RadioQuestion from './inputs/radio';
import TextQuestion from './inputs/text';
import './schedule_appointment.scss';
import Modal from './schedule_appointment_modal_container';

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

const cookieExpiration = 34 * 60 * 1000;
class ScheduleAppointment extends React.Component {
  constructor(props) {
    super(props);

    this.poyntCode = props.config.poyntCode;
    const payConfig = $$.keys.only(props.config, [
      'ccHoldEnabled',
      'ccHoldText',
      'ccHoldTextTranslated',
      'ccHoldAppointments',
      'ccDepositText',
      'ccDepositText',
      'ccDepositTextTranslated',
      'ccDepositEnabled',
      'ccDepositAmount',
      'ccDepositAppointments',
      'merchant',
      'paymentsActive',
      'stripeConnectedAccountId',
      'surchargingEnabled',
      'surchargingMaxRate',
    ]);
    let ccHandleMode;
    const appointmentId = window.sessionStorage.appointmentId;

    if (payConfig.merchant) {
      payConfig.paymentsActive = true;
      if (
        payConfig.ccHoldEnabled &&
        payConfig.ccHoldAppointments &&
        payConfig.ccHoldAppointments.includes(appointmentId)
      ) {
        ccHandleMode = 'hold';
      }
      // If the appt type is flagged for deposits, we'll go w/ that
      if (
        payConfig.ccDepositEnabled &&
        payConfig.ccDepositAppointments &&
        payConfig.ccDepositAppointments.includes(appointmentId)
      ) {
        ccHandleMode = 'deposit';
      }
    }

    this.state = {
      fname: '',
      lname: '',
      dob: '',
      email: '',
      phone: '',
      hasInsurance: '',
      insurance: '',
      insuranceOther: 'No',
      selectedOption: null,
      showInsuranceSelection: false,
      showInsuranceMessage: false,
      showNoInsuranceMessage: false,
      show: false,
      insurance_change: false,
      showCodeAlert: 'show',
      subscriber_id: '',
      loading: false,
      returning: window.sessionStorage.patientType,
      hover: JSON.parse(window.sessionStorage.phoneType || true),
      ccAgree: false,
      moolahNonceComplete: false,
      ccHandleMode,
      ccApptIncluded:
        (payConfig.ccHoldEnabled &&
          payConfig.ccHoldAppointments?.includes(appointmentId)) ||
        (payConfig.ccDepositEnabled &&
          payConfig.ccDepositAppointments?.includes(appointmentId)),
      verifyingAndScheduling: false,
      submitting: false,
      ...payConfig,
      ccTokenReady: false,
      stripeReady: false,
      stripePaymentMethod: null,
      showGuarantorModal: !!props.config.checkForGuarantor,
      scheduleFor: null,
      guarantor: null,
      dobAlert: false,
      emailAlert: false,
      paymentError: null,
      submitError: null,
      submitErrorField: null,
      paymentIntentId: null,
      setupIntentId: null,
      scaInProgress: false,
      scaClientSecret: null,
      scaResult: null,
      scaIntentType: null,
      returnUrlPayload: null,
      surchargeDisclosure: null,
      surchargeSubmitData: null,
      surchargeReuse: null,
      confirmingSurcharge: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMoolahSubmit = this.handleMoolahSubmit.bind(this);
    this.handleDob = this.handleDob.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleInsurance = this.handleInsurance.bind(this);
    this.updateInsurance = this.updateInsurance.bind(this);
    this.updateReturningInsurance = this.updateReturningInsurance.bind(this);
    this.doNotUpdateReturningInsurance = this.doNotUpdateReturningInsurance.bind(this);
    this.buttonSelected = this.buttonSelected.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleCardDataSync = this.handleCardDataSync.bind(this);

    // Create refs for form inputs (replaces deprecated string refs)
    this.inputRefs = {
      fname: React.createRef(),
      lname: React.createRef(),
      email: React.createRef(),
      month: React.createRef(),
      day: React.createRef(),
      year: React.createRef(),
      phone: React.createRef(),
    };
  }

  async initStripe() {
    const publicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    if (!publicKey) {
      console.error('Missing REACT_APP_STRIPE_PUBLIC_KEY');
      Sentry.captureMessage('Missing REACT_APP_STRIPE_PUBLIC_KEY', {
        level: 'error',
        tags: { component: 'ScheduleAppointment', method: 'initStripe' },
        extra: { clientId: this.getClientId() },
      });
      return null;
    }

    const options = this.state.stripeConnectedAccountId
      ? { stripeAccount: this.state.stripeConnectedAccountId }
      : {};

    try {
      const stripe = await loadStripe(publicKey, options);
      this.stripe = stripe;
      return stripe;
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'ScheduleAppointment', method: 'initStripe' },
        extra: { clientId: this.getClientId() },
      });
      console.error('Failed to initialize Stripe:', error);
      return null;
    }
  }

  async initMoolah(e) {
    await $.getScript('https://poynt.net/snippet/poynt-collect/bundle.js');
    const collect = new window.TokenizeJs(
      this.poyntCode,
      'urn:aid:df5ae5f0-6360-4024-819f-b7a17b92d5c7',
    );

    const options = {
      iFrame: {
        width: '100%',
        height: '170px',
        border: '0',
      },
      style: {
        theme: 'customer',
      },
      displayComponents: {
        firstName: false,
        lastName: false,
        emailAddress: false,
        submitButton: false,
        showEndingPage: false,
        labels: true,
        zipCode: true,
      },
    };
    collect.mount('moolah-payment-iframe', document, options);
    collect.on('nonce', (data) => {
      if (!data?.type === 'nonce') {
        return;
      }

      this.token = data.data.nonce;
      this.lastfour = '1234';
      this.expiry = '1250';
      this.setState({ moolahNonceComplete: true });
      this.clearPaymentError();
      this.handleSubmit();
    });

    //error handling if fields are missing or invalids
    collect.on('error', (event) => {
      this.setState({ submitting: false });
      if (
        event &&
        event.data &&
        event.data.error &&
        event.data.error.source === 'submit'
      ) {
        alert(event.data.error.message);
      }
    });
    this.collect = collect;
  }

  getClientId() {
    return window.sessionStorage.locationId || this.props.match?.params?.id || 'unknown';
  }

  componentDidMount() {
    const clientId = this.getClientId();
    Sentry.setTag('clientId', clientId);
    Sentry.setContext('practice', {
      clientId,
      appointmentId: window.sessionStorage.appointmentId,
    });

    const urlParams = new URLSearchParams(window.location.search);
    const clientSecret =
      urlParams.get('payment_intent_client_secret') ||
      urlParams.get('setup_intent_client_secret');

    if (clientSecret) {
      const intentType = urlParams.get('payment_intent_client_secret')
        ? 'payment'
        : 'setup';

      this.initStripe().then((stripe) => {
        if (stripe) {
          this.checkIntentStatus(clientSecret, intentType);
        } else {
          console.error('Failed to initialize Stripe for authentication');
        }
      });

      return;
    }

    // Check for state restoration from 3DS redirects
    this.restoreStateFromURL();

    //blur background for who is scheduling modal
    if (this.state.showGuarantorModal) {
      const background = document.getElementById('scrollTop');
      background.classList.add('remove-scroll');
    }
    if (
      this.state.paymentsActive &&
      this.state.ccApptIncluded &&
      this.state.merchant === 'moolah'
    ) {
      this.TokenizeJs = window.TokenizeJs;
      this.authorize = window.authorize;
      this.initMoolah();
    }
    if (
      this.state.paymentsActive &&
      this.state.ccApptIncluded &&
      this.state.merchant === 'cardconnect'
    ) {
      const env =
        process.env.REACT_APP_USE_CARDCONNECT_TEST_ENDPOINT === 'true' ? 'uat' : 'prod';
      const container = document.getElementById('cardconnect-iframe');
      if (container) {
        this.ccDetach = CardConnectAdapter.attach(container, {
          env,
          onToken: ({ token, expiry }) => {
            this.ccToken = token;
            this.ccExpiry = expiry;
            this.setState({ ccTokenReady: true });
            this.clearPaymentError();
          },
          onError: (error) => {
            this.ccToken = null;
            this.ccExpiry = null;
            this.setState({ ccTokenReady: false });
          },
        });
      }
    }
    if (
      this.state.paymentsActive &&
      this.state.ccApptIncluded &&
      this.state.merchant === 'stripe'
    ) {
      this.initStripe();
    }
    const scrolly = document.getElementsByClassName('scheduleAppointmentContainer');
    scrolly[0].scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      window.sessionStorage.setItem('phoneType', true);
      this.setState({ hover: false });
    } else {
      window.sessionStorage.setItem('phoneType', false);
      this.setState({ hover: true });
    }

    const currentPage = window.sessionStorage.currentPage;

    if (window.location !== window.parent.location) {
      if (parseInt(currentPage) === 8) {
        window.sessionStorage.setItem('currentPage', 9);
      } else if (parseInt(currentPage) === 10) {
        if (this.props.match.params.analytics !== undefined) {
          this.props.history.push(
            `/${this.props.match.params.id}/${this.props.match.params.analytics}/${
              parseInt(currentPage) !== 0 ? currentPage : ''
            }`,
          );
        } else {
          this.props.history.push(
            `/${this.props.match.params.id}/${
              parseInt(currentPage) !== 0 ? currentPage : ''
            }`,
          );
        }
      } else {
        if (this.props.match.params.analytics !== undefined) {
          this.props.history.push(
            `/${this.props.match.params.id}/${this.props.match.params.analytics}/${
              parseInt(currentPage) !== 0 ? currentPage : ''
            }`,
          );
        } else {
          this.props.history.push(
            `/${this.props.match.params.id}/${
              parseInt(currentPage) !== 0 ? currentPage : ''
            }`,
          );
        }
      }
    } else if (parseInt(currentPage) === 10) {
      if (this.props.match.params.analytics !== undefined) {
        this.props.history.push(
          `/${this.props.match.params.id}/${this.props.match.params.analytics}/${
            parseInt(currentPage) !== 0 ? currentPage : ''
          }`,
        );
      } else {
        this.props.history.push(
          `/${this.props.match.params.id}/${
            parseInt(currentPage) !== 0 ? currentPage : ''
          }`,
        );
      }

      window.securedNav = false;
    } else {
      if (parseInt(currentPage) === 8 || parseInt(currentPage) === 9) {
        window.sessionStorage.setItem('currentPage', 9);
      } else {
        if (window.securedNav === true && parseInt(currentPage) === 2) {
          window.sessionStorage.setItem('currentPage', 1);
        } else {
          if (this.props.match.params.analytics !== undefined) {
            this.props.history.replace(
              `/${this.props.match.params.id}/${this.props.match.params.analytics}/${
                parseInt(currentPage) !== 0 ? parseInt(currentPage) - 1 : ''
              }`,
            );
          } else {
            this.props.history.replace(
              `/${this.props.match.params.id}/${
                parseInt(currentPage) !== 0 ? parseInt(currentPage) - 1 : ''
              }`,
            );
          }
        }
      }

      window.securedNav = false;
    }

    let returning = this.state.returning;

    if (returning !== 'new') {
      this.setState({
        insurance: 'already provided',
      });
    }
  }

  componentWillUnmount() {
    // Cleanup CardConnect adapter and zeroize
    if (this.ccDetach) {
      try {
        this.ccDetach();
      } catch (e) {}
      this.ccDetach = null;
    }
    this.ccToken = null;
    this.ccExpiry = null;
    this.setState && this.setState({ ccTokenReady: false });
    this.stripe = null;
    this.stripeElements = null;
    this.setState && this.setState({ stripeReady: false, stripePaymentMethod: null });
  }

  handleKeyPress(value, event) {
    if (event.key === 'Enter') {
      const arr = ['fname', 'lname', 'email', 'month', 'day', 'year', 'phone'];
      const nextField = arr[arr.indexOf(value) + 1];
      if (nextField && this.inputRefs[nextField]?.current) {
        this.inputRefs[nextField].current.focus();
      }
    }
  }

  filterValue(obj, key, value) {
    return obj.find(function (v) {
      return v[key] === value;
    });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.verify !== this.props.verify && this.props.verify === 'approved') {
      this.setState({ verifyingAndScheduling: true, submitting: true });
      const appointmentId = window.sessionStorage.appointmentId;
      let scheduleApp = JSON.parse(window.sessionStorage.selectedAppointment);
      let returning = this.state.returning;
      let insurance_change = false;

      let providerId = window.sessionStorage.providerId;

      let providerIdx = this.props.config.providers.findIndex(
        (providers) => parseInt(providerId) === parseInt(providers.provider_assoc),
      );
      let foundProvider = this.props.config.providers[providerIdx];

      if (foundProvider) {
        providerId = foundProvider.provider_id;
      }

      if (returning === 'new') {
        returning = false;
      } else if (returning === 'returningUpdate') {
        returning = true;
        insurance_change = true;
      } else {
        returning = true;
      }

      if (typeof scheduleApp === 'object' && scheduleApp.length > 0) {
        scheduleApp = scheduleApp[0];
      }

      let client;

      if (window.sessionStorage.locationId) {
        client = window.sessionStorage.locationId;
      } else {
        client = this.props.match.params.id;
      }

      let insurance;

      if (
        this.state.hasInsurance === 'Yes' &&
        this.state.selectedOption.label &&
        this.state.selectedOption.label !== 'Other'
      ) {
        insurance = this.state.selectedOption.label;
      } else {
        insurance = this.state.insuranceOther;
      }

      let number = this.state.phone.replace(/[^\d]/g, '');

      var qAs = [];

      const currentLanguageName = getFullLanguageName();

      var questions =
        this.props.config.questions !== undefined ? this.props.config.questions : [];

      questions.forEach((el) => {
        const addQuestion =
          !el.enable_appt_types ||
          (el.enable_appt_types && el.appointmentTypes.includes(+appointmentId));
        if (addQuestion) {
          var qA = {
            q: el.question,
            a:
              this.state[`question-${el.id}`] !== undefined
                ? this.state[`question-${el.id}`]
                : '',
          };
          qAs.push(qA);
        }
      });

      let data = {
        client: client,
        fname: this.state.fname,
        lname: this.state.lname,
        email: this.state.email,
        dob: this.state.dob,
        phone: number,
        appointment_id: appointmentId,
        appointment_date: scheduleApp.date,
        appointment_time: scheduleApp.starttime,
        operatory: scheduleApp.operatory,
        provider_id: providerId,
        returning: returning,
        insurance: insurance,
        insuranceChange: insurance_change,
        language: currentLanguageName,
        subscriber_id: this.state.subscriber_id !== '' ? this.state.subscriber_id : '0',
        tracking: this.props.match.params.analytics,
        qas: qAs,
        guarantor: this.state.guarantor,
        liineSessionId: window.sessionStorage.getItem('liineSessionId'),
        appointmentName: window.sessionStorage.getItem('appointmentName'),
      };

      if (this.isSurchargeDepositFlow()) {
        const unblur = () => {
          const background = document.getElementsByClassName('blurry');
          $(background).attr('style', 'filter: none');
          const scrollContainer = document.getElementById('scrollTop');
          if (scrollContainer) {
            scrollContainer.classList.remove('remove-scroll');
          }
        };
        try {
          this.setState({ submitting: true });
          await this.startSurchargeQuote(data);
          unblur();
          this.setState({ show: false });
        } catch (error) {
          Sentry.captureException(error, {
            tags: {
              component: 'ScheduleAppointment',
              method: 'componentDidUpdate.surchargeQuote',
            },
            extra: { clientId: this.getClientId() },
          });
          unblur();
          this.setState({
            loading: false,
            submitting: false,
            show: false,
            paymentError:
              error?.message ||
              'Unable to calculate the surcharge. Please check your card details and try again.',
          });
        }
        return;
      }

      await this.handleCreditCard(data);
      const cardToken = data.token || data.confirmationTokenId;
      if (cardToken) {
        data.idempotencyKey = this.mintIdempotencyKey(cardToken);
      }

      try {
        const response = await this.props.createAppointment(data);
        const responseData = response?.data;

        if (responseData?.status === 'requires_payment_method') {
          const background = document.getElementsByClassName('blurry');
          $(background).attr('style', 'filter: none');

          const scrollContainer = document.getElementById('scrollTop');
          if (scrollContainer) {
            scrollContainer.classList.remove('remove-scroll');
          }

          this.setState({
            loading: false,
            submitting: false,
            show: false,
            paymentError:
              responseData.error ||
              'Your payment requires additional verification. Please check your card information and try submitting again.',
            paymentIntentId: responseData.paymentIntentId || null,
            setupIntentId: responseData.setupIntentId || null,
          });
          return;
        }

        if (responseData?.status === 'requires_action') {
          this.setState({ submitting: false });
          this.handleStripeAuthentication({
            clientSecret: responseData.clientSecret,
            intentType: responseData.paymentIntentId ? 'payment' : 'setup',
            paymentIntentId: responseData.paymentIntentId,
            setupIntentId: responseData.setupIntentId,
          });
          return;
        }

        window.sessionStorage.setItem('created', this.props.appointments);
        window.sessionStorage.setItem('currentPage', 9);
        this.createCookieInHour(
          this.state.guarantor ? this.state.guarantor.phone : this.state.phone,
          'approved',
          1,
        );

        this.setState({
          loading: false,
          submitting: false,
          show: !this.state.show,
          paymentError: null,
        });

        if (this.props.match.params.analytics !== undefined) {
          this.props.history.push(
            `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
          );
        } else {
          this.props.history.push(`/${this.props.match.params.id}/10`);
        }
      } catch (error) {
        Sentry.captureException(error, {
          tags: { component: 'ScheduleAppointment', method: 'componentDidUpdate' },
          extra: { clientId: this.getClientId(), appointmentId: data.appointment_id },
        });

        const errorData = error?.response?.data;
        const background = document.getElementsByClassName('blurry');
        $(background).attr('style', 'filter: none');

        const scrollContainer = document.getElementById('scrollTop');
        if (scrollContainer) {
          scrollContainer.classList.remove('remove-scroll');
        }

        if (
          errorData?.status === 'requires_payment_method' ||
          errorData?.status === 'payment_error'
        ) {
          this.setState({
            loading: false,
            submitting: false,
            show: false,
            paymentError:
              errorData.error ||
              (errorData?.status === 'requires_payment_method'
                ? 'Your payment requires additional verification. Please check your card information and try submitting again.'
                : 'Payment failed. Please check your payment information and try again.'),
            paymentIntentId: errorData.paymentIntentId || null,
            setupIntentId: errorData.setupIntentId || null,
          });
        } else {
          this.setState({ loading: false, submitting: false, show: false });
          this.goToCreateError();
        }
      }
    }
  }

  handleScheduleFor = (answer) => {
    if (answer === 'myself') {
      this.setState({ scheduleFor: answer, showGuarantorModal: false }, () => {
        const background = document.getElementById('scrollTop');
        background.classList.remove('remove-scroll');
      });
    } else if (answer === 'someoneElse') {
      this.setState({ scheduleFor: answer });
    }
  };

  /**
   * @typedef {Object} GuarantorInfo
   * @property {boolean} isGuarantor
   * @property {string} fname
   * @property {string} lname
   * @property {string} email
   * @property {string} phone
   * @property {string} dob
   */
  /**
   * @param {GuarantorInfo} guarantor
   */
  handleCloseGuarantorModal = (guarantor) => {
    this.setState({ guarantor, showGuarantorModal: false }, () => {
      const background = document.getElementById('scrollTop');
      background.classList.remove('remove-scroll');
    });
  };

  handleShowGuarantorModal = (e) => {
    e.preventDefault();
    this.setState({ showGuarantorModal: true }, () => {
      const modal = document.getElementById('scheduler-modal');
      modal.scrollIntoView({ behavior: 'smooth', block: 'end' });
      const background = document.getElementById('scrollTop');
      background.classList.add('remove-scroll');
    });
  };

  showModal = (e) => {
    const closing = this.state.show;
    this.setState(
      {
        show: !this.state.show,
        ...(closing ? { submitting: false } : { verifyingAndScheduling: false }),
      },
      () => {
        if (document.getElementById('modal')) {
          this.scrollToModal();
        }
      },
    );

    if (!this.state.show) {
      const background = document.getElementsByClassName('blurry');
      $(background).attr('style', 'filter: blur(5px);');
    } else {
      const background = document.getElementsByClassName('blurry');
      $(background).attr('style', 'filter: none');
    }
  };

  getCookie(name) {
    let dc = document.cookie;
    let prefix = name + '=';
    let begin = dc.indexOf('; ' + prefix);
    let end;

    if (parseInt(begin) === -1) {
      begin = dc.indexOf(prefix);
      if (begin === -1) return null;
      end = document.cookie.indexOf(';', begin);
      if (end === -1) {
        end = dc.length;
      }
    } else {
      begin += 2;
      end = document.cookie.indexOf(';', begin);

      if (parseInt(end) === -1) {
        end = dc.length;
      }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  async handleCreditCard(data) {
    //tokenize card
    if (
      !(this.state.paymentsActive && this.state.ccApptIncluded && this.state.ccHandleMode)
    ) {
      return;
    }
    if (this.state.merchant === 'cardconnect') {
      if (!this.ccToken || !this.ccExpiry) {
        return;
      }
      data.token = this.ccToken;
      data.expiry = this.ccExpiry.toString();
      data.lastfour = this.ccToken.slice(-4);
    } else if (this.state.merchant === 'moolah') {
      data.token = this.token;
      data.expiry = this.expiry;
    } else if (this.state.merchant === 'stripe') {
      if (!this.stripe || !this.stripeElements) {
        console.error('Stripe not initialized');
        return;
      }
      try {
        const { error: submitError } = await this.stripeElements.submit();
        if (submitError) {
          throw submitError;
        }
        // Encode current state for return_url to restore after 3DS redirects
        const osState = {
          appointmentId: window.sessionStorage.appointmentId,
          providerId: window.sessionStorage.providerId,
          locationId: window.sessionStorage.locationId,
          selectedAppointment: window.sessionStorage.selectedAppointment,
          patientType: window.sessionStorage.patientType,
          currentPage: window.sessionStorage.currentPage,
        };
        const encodedState = btoa(JSON.stringify(osState));
        const returnUrl = `${window.location.origin}${window.location.pathname}?state=${encodedState}`;

        const confirmationToken = await createConfirmationToken(
          this.stripe,
          this.stripeElements,
          { return_url: returnUrl },
        );

        data.confirmationTokenId = confirmationToken.id;
        data.returnUrl = returnUrl;
        data.lastfour = confirmationToken.payment_method_preview?.card?.last4 || '****';
        data.merchant = 'stripe';

        // Include existing intent IDs for payment error resubmission
        if (this.state.paymentIntentId) {
          data.paymentIntentId = this.state.paymentIntentId;
        }
        if (this.state.setupIntentId) {
          data.setupIntentId = this.state.setupIntentId;
        }
      } catch (error) {
        Sentry.captureException(error, {
          tags: { component: 'ScheduleAppointment', method: 'handleCreditCard' },
          extra: { clientId: this.getClientId() },
        });
        console.error('Stripe confirmation token creation failed:', error);
        throw error;
      }
    } else {
      console.error('Unrecognized vendor: ', this.state.merchant);
    }
  }

  update(field) {
    return (e) => {
      this.setState({ [field]: e.target.value, submitError: null, submitErrorField: null });
    };
  }

  scrollToBottom() {
    if (JSON.parse(window.sessionStorage.phoneType))
      this.el.getElementsByTagName('button')[0].scrollIntoView({ behavior: 'smooth' });
  }

  scrollToBottomPage() {
    const first = document.getElementById('scrollTop');
    if (JSON.parse(window.sessionStorage.phoneType))
      first.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  scrollToFirst() {
    const first = document.getElementById('firstInput');
    if (JSON.parse(window.sessionStorage.phoneType))
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollToLast() {
    const last = document.getElementById('lastInput');
    if (JSON.parse(window.sessionStorage.phoneType))
      last.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollToEmail() {
    const email = document.getElementById('emailInput');
    if (JSON.parse(window.sessionStorage.phoneType))
      email.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollToPhone() {
    const phone = document.getElementById('phoneInput');
    if (JSON.parse(window.sessionStorage.phoneType))
      phone.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollToModal() {
    const modal = document.getElementById('modal');
    if (JSON.parse(window.sessionStorage.phoneType))
      modal.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  handleDob(e) {
    const month = document.getElementById('date-of-birth-month');
    const day = document.getElementById('date-of-birth-day');
    const year = document.getElementById('date-of-birth-year');
    if (!+day.value || !year.value) {
      this.setState({ dob: '', dobAlert: false });
      this.update('dob');
      return;
    }

    const currentYear = new Date().getFullYear();
    if (day.value && day.value < 1) day.value = 1;
    if (day.value && day.value > 31) day.value = 31;
    if (year.value && year.value.length >= 4 && year.value < 1900) year.value = 1900;
    if (year.value && year.value.length >= 4 && year.value > currentYear)
      year.value = currentYear;
    if (year.value.length < 4) {
      this.setState({ dob: '', dobAlert: false });
      this.update('dob');
      return;
    }
    let dayVal = day.value;

    let monthVal = month.options[month.selectedIndex].value;
    if (monthVal.length === 1) monthVal = '0' + monthVal;
    if (dayVal.length === 1) dayVal = '0' + day.value;
    const dobVal = year.value + '-' + monthVal + '-' + dayVal;
    if (
      moment(dobVal, 'YYYY-MM-DD', true).isValid() &&
      moment(dobVal, 'YYYY-MM-DD').isBefore()
    ) {
      this.setState({ dob: dobVal, dobAlert: false });
      this.update('dob');
    } else {
      this.setState({ dob: '', dobAlert: true });
      this.update('dob');
    }
  }

  handleEmail() {
    let email = document.getElementById('email');
    if (
      email.value.length < 5 ||
      !email.value.includes('@') ||
      !email.value.includes('.')
    ) {
      this.setState({ email: email.value, emailAlert: true });
    } else {
      this.setState({
        email: email.value,
        emailAlert: false,
        submitError: null,
        submitErrorField: null,
      });
    }
  }
  async handleMoolahSubmit(e) {
    e && e.preventDefault();

    this.setState({ paymentError: null });

    if (!this.ccAgree && this.state.merchant !== 'stripe') {
      alert('Must check the "I understand" box');
      return;
    }
    if (this.state.submitting || this._creating) return;
    this.setState({ submitting: true });
    this.collect.getNonce({});
  }
  mintIdempotencyKey(cardToken) {
    const slot = `${window.sessionStorage.appointmentId}|${window.sessionStorage.selectedAppointment}`;
    return `os-deposit:${slot}:${cardToken}`;
  }

  isSurchargeDepositFlow() {
    return Boolean(
      this.state.surchargingEnabled &&
        this.state.merchant === 'stripe' &&
        this.state.ccHandleMode === 'deposit' &&
        this.state.ccApptIncluded &&
        this.state.paymentsActive,
    );
  }

  async startSurchargeQuote(data) {
    const paymentMethod = await createPaymentMethod(this.stripe, this.stripeElements);

    const response = await surchargeQuote({
      ...data,
      paymentMethodId: paymentMethod.id,
      idempotencyKey: this.mintIdempotencyKey(paymentMethod.id),
      paymentIntentId: this.state.surchargeReuse?.paymentIntentId,
      yeeldTransactionId: this.state.surchargeReuse?.yeeldTransactionId,
    });
    const quote = response?.data || response;

    const disclosure = {
      surcharge: quote.surcharge,
      amount: quote.amount,
      total: quote.total,
      paymentIntentId: quote.paymentIntentId,
      clientSecret: quote.clientSecret,
      yeeldTransactionId: quote.yeeldTransactionId,
      lastfour: paymentMethod.card?.last4 || '****',
    };

    this.setState({
      loading: false,
      submitting: false,
      surchargeSubmitData: data,
      surchargeReuse: {
        paymentIntentId: quote.paymentIntentId,
        yeeldTransactionId: quote.yeeldTransactionId,
      },
      surchargeDisclosure: quote.surcharge > 0 ? disclosure : null,
    });

    if (!(quote.surcharge > 0)) {
      this._creating = false;
      await this.finalizeSurchargedDeposit(disclosure, data);
    }
  }

  async handleConfirmSurcharge() {
    await this.finalizeSurchargedDeposit(
      this.state.surchargeDisclosure,
      this.state.surchargeSubmitData,
    );
  }

  async finalizeSurchargedDeposit(disclosure, submitData) {
    if (!disclosure || !submitData || this._creating) return;
    this._creating = true;
    this.setState({ confirmingSurcharge: true, loading: true, paymentError: null });

    try {
      await confirmPayment(
        this.stripe,
        disclosure.clientSecret,
        disclosure.paymentIntentId,
        { surcharge: disclosure.surcharge },
      );

      const data = {
        ...submitData,
        merchant: 'stripe',
        lastfour: disclosure.lastfour,
        paymentIntentId: disclosure.paymentIntentId,
        resumingFromSavedState: true,
        idempotencyKey: this.mintIdempotencyKey(disclosure.paymentIntentId),
      };

      const response = await this.props.createAppointment(data);
      const responseData = response?.data || response;

      if (responseData?.status && responseData.status !== 'created') {
        this.setState({
          loading: false,
          confirmingSurcharge: false,
          surchargeDisclosure: null,
          paymentError:
            responseData.error ||
            'We could not finish booking your appointment. Please contact the office.',
        });
        return;
      }

      window.sessionStorage.setItem('created', this.props.appointments);
      window.sessionStorage.removeItem('backPage');
      window.sessionStorage.setItem('currentPage', 9);
      this.createCookieInHour(
        this.state.guarantor ? this.state.guarantor.phone : this.state.phone,
        'approved',
        1,
      );
      this.setState({
        loading: false,
        confirmingSurcharge: false,
        surchargeDisclosure: null,
        surchargeReuse: null,
        paymentError: null,
      });

      if (this.props.match.params.analytics !== undefined) {
        this.props.history.push(
          `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
        );
      } else {
        this.props.history.push(`/${this.props.match.params.id}/10`);
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'ScheduleAppointment', method: 'handleConfirmSurcharge' },
        extra: { clientId: this.getClientId() },
      });
      this.setState({
        loading: false,
        confirmingSurcharge: false,
        paymentError:
          error?.message ||
          'Payment failed. Please try again or use a different card.',
      });
    } finally {
      this._creating = false;
    }
  }

  handleChangeCard() {
    this.setState({
      surchargeDisclosure: null,
      confirmingSurcharge: false,
      paymentError: null,
    });
  }

  renderScheduleButtonLabel() {
    const label = this.props.t
      ? this.props.t('Schedule Appointment')
      : 'Schedule Appointment';
    return (
      <span className="sched-btn-label">
        <span style={{ visibility: this.state.submitting ? 'hidden' : 'visible' }}>
          {label}
        </span>
        {this.state.submitting && (
          <span className="sched-btn-spinner">
            <PulseLoader
              color={getContrast(this.props.config.color || '#2699fb')}
              size={8}
            />
          </span>
        )}
      </span>
    );
  }

  async handleSubmit(e) {
    e && e.preventDefault();

    this.setState({ paymentError: null, submitError: null, submitErrorField: null });

    const invalidInput = this.validatePatientInput();
    if (invalidInput) {
      this.setState({
        submitError: invalidInput.message,
        submitErrorField: invalidInput.field,
      });
      // Move focus to the first invalid field (a11y SHO_133).
      this.inputRefs[invalidInput.field]?.current?.focus();
      return;
    }

    let data = {};
    const qAs = [];
    const appointmentId = window.sessionStorage.appointmentId;

    if (this.state.guarantor?.dob === this.state.dob) {
      alert(
        'You have indicated that you are booking this appointment for someone else; however, the date of birth provided on this page matches the date of birth provided on the previous page. Please ensure your information is provided on the previous page and the patient’s information is provided on this page.',
      );
      this.setState({ dobAlert: true });
      return;
    } else {
      this.state.dobAlert && this.setState({ dobAlert: false });
    }

    if (this.state.paymentsActive && this.state.ccHandleMode) {
      const alerts = [];
      if (this.state.merchant === 'cardconnect' && !this.state.ccTokenReady) {
        alerts.push('Missing or invalid credit card information');
      }
      if (this.state.merchant === 'stripe' && !this.state.stripeReady) {
        alerts.push('Missing or invalid credit card information');
      }
      if (!this.ccAgree && this.state.merchant !== 'stripe') {
        alerts.push('Must check the "I understand" box');
      }
      if (alerts.length) {
        alert(alerts.join(', '));
        return;
      }
    }

    var questions =
      this.props.config.questions !== undefined ? this.props.config.questions : [];

    questions.forEach((el) => {
      const addQuestion =
        !el.enable_appt_types ||
        (el.enable_appt_types && el.appointmentTypes.includes(+appointmentId));
      if (addQuestion) {
        const qA = {
          q: el.question,
          a:
            this.state[`question-${el.id}`] !== undefined
              ? this.state[`question-${el.id}`]
              : '',
        };
        qAs.push(qA);
      }
    });
    const myCookie = this.getCookie(
      this.state.guarantor ? this.state.guarantor.phone : this.state.phone,
    );
    let scheduleApp = JSON.parse(window.sessionStorage.selectedAppointment);
    let returning = this.state.returning;
    let insurance_change = false;

    let providerId = window.sessionStorage.providerId;

    let providerIdx = this.props.config.providers.findIndex(
      (providers) => parseInt(providerId) === parseInt(providers.provider_assoc),
    );
    let foundProvider = this.props.config.providers[providerIdx];

    if (foundProvider) {
      providerId = foundProvider.provider_id;
    }

    if (returning === 'new') {
      returning = false;
    } else if (returning === 'returningUpdate') {
      returning = true;
      insurance_change = true;
    } else {
      returning = true;
    }

    if (typeof scheduleApp === 'object' && scheduleApp.length > 0) {
      scheduleApp = scheduleApp[0];
    }

    let client;

    if (window.sessionStorage.locationId) {
      client = window.sessionStorage.locationId;
    } else {
      client = this.props.match.params.id;
    }

    let insurance;

    if (
      this.state.hasInsurance === 'Yes' &&
      this.state.selectedOption.label &&
      this.state.selectedOption.label !== 'Other'
    ) {
      insurance = this.state.selectedOption.label;
    } else {
      insurance = this.state.insuranceOther;
    }

    let number = this.state.phone.replace(/[^\d]/g, '');

    const currentLanguageName = getFullLanguageName();

    data = {
      client: client,
      fname: this.state.fname,
      lname: this.state.lname,
      email: this.state.email,
      dob: this.state.dob,
      phone: number,
      appointment_id: appointmentId,
      appointment_date: scheduleApp.date,
      appointment_time: scheduleApp.starttime,
      operatory: scheduleApp.operatory,
      provider_id: providerId,
      returning: returning,
      insurance: insurance,
      insuranceChange: insurance_change,
      language: currentLanguageName,
      subscriber_id: this.state.subscriber_id !== '' ? this.state.subscriber_id : '0',
      tracking: this.props.match.params.analytics,
      qas: qAs,
      guarantor: this.state.guarantor,
      liineSessionId: window.sessionStorage.getItem('liineSessionId'),
      appointmentName: window.sessionStorage.getItem('appointmentName'),
      merchant: this.state.merchant,
    };

    // Create appointment
    if (myCookie) {
      if (myCookie === 'approved') {
        if (this._creating) return;
        this._creating = true;

        this.setState({ submitting: true });
        try {
          if (this.isSurchargeDepositFlow()) {
            try {
              await this.startSurchargeQuote(data);
            } catch (error) {
              Sentry.captureException(error, {
                tags: {
                  component: 'ScheduleAppointment',
                  method: 'handleSubmit.surchargeQuote',
                },
                extra: { clientId: this.getClientId() },
              });
              this.setState({
                loading: false,
                submitting: false,
                paymentError:
                  error?.message ||
                  'Unable to calculate the surcharge. Please check your card details and try again.',
              });
            }
            return;
          }

          await this.handleCreditCard(data);
          const cardToken = data.token || data.confirmationTokenId;
          if (cardToken) {
            data.idempotencyKey = this.mintIdempotencyKey(cardToken);
          }
          this.setState({ loading: true });
          const response = await this.props.createAppointment(data);
          const responseData = response?.data || response;

          if (
            responseData?.status === 'payment_error' ||
            responseData?.status === 'requires_payment_method'
          ) {
            this.setState({
              loading: false,
              submitting: false,
              show: false,
              paymentError:
                responseData.error ||
                (responseData?.status === 'requires_payment_method'
                  ? 'Your payment requires additional verification. Please check your card information and try submitting again.'
                  : 'Payment failed. Please check your payment information and try again.'),
              paymentIntentId: responseData.paymentIntentId || null,
              setupIntentId: responseData.setupIntentId || null,
            });
            return;
          }

          if (responseData?.status === 'requires_action') {
            this.setState({ loading: false, submitting: false });
            this.handleStripeAuthentication({
              clientSecret: responseData.clientSecret,
              intentType: responseData.paymentIntentId ? 'payment' : 'setup',
              paymentIntentId: responseData.paymentIntentId,
              setupIntentId: responseData.setupIntentId,
            });
            return;
          }

          // Success path - appointment created
          window.sessionStorage.setItem('created', this.props.appointments);
          this.setState({
            loading: false,
            submitting: false,
            paymentError: null,
          });
          window.sessionStorage.removeItem('backPage');
          window.sessionStorage.setItem('currentPage', 9);

          if (this.props.match.params.analytics !== undefined) {
            this.props.history.push(
              `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
            );
          } else {
            this.props.history.push(`/${this.props.match.params.id}/10`);
          }
        } catch (error) {
          Sentry.captureException(error, {
            tags: { component: 'ScheduleAppointment', method: 'handleSubmit' },
            extra: { clientId: this.getClientId(), appointmentId: data.appointment_id },
          });

          const errorData = error?.response?.data;
          if (
            errorData?.status === 'payment_error' ||
            errorData?.status === 'requires_payment_method'
          ) {
            const errorMessage =
              errorData.error ||
              (errorData?.status === 'requires_payment_method'
                ? 'Your payment requires additional verification. Please check your card information and try submitting again.'
                : 'Payment failed. Please check your payment information and try again.');

            this.setState({
              loading: false,
              submitting: false,
              show: false,
              paymentError: errorMessage,
              paymentIntentId: errorData.paymentIntentId || null,
              setupIntentId: errorData.setupIntentId || null,
            });
          } else {
            this.setState({ loading: false, submitting: false, show: false });
            this.goToCreateError();
          }
        } finally {
          this._creating = false;
        }
      } else {
        this.showModal();

        // this is used to handle tracking insurance use. will display insurance selection on next appointment creation, or button to change
        this.props.sendVerification(
          this.state.guarantor ? this.state.guarantor.phone : this.state.phone,
        );
      }
    } else {
      this.showModal();

      // this is used to handle tracking insurance use. will display insurance selection on next appointment creation, or button to change
      this.props.sendVerification(
        this.state.guarantor ? this.state.guarantor.phone : this.state.phone,
      );
    }
  }

  handleInsurance(selectedOption) {
    this.setState({
      selectedOption,
      showInsuranceMessage: true,
    });

    if (selectedOption.label === 'Other') {
      this.setState(
        {
          showInsuranceField: true,
        },
        () => {
          this.scrollToBottom();
        },
      );
    }
  }

  handlePhone(phoneNumber) {
    let ph = phoneNumber.currentTarget.value
      .replace(/\D/g, '')
      .replace(/^1/, '')
      .substring(0, 10);

    let len = parseInt(ph.length);

    if (len < 3) {
      ph = '(' + ph;
    } else if (len === 3) {
      ph = '(' + ph + ') ';
    } else if (len < 6) {
      ph = '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6);
    } else if (len === 6) {
      ph = '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6) + '-';
    } else {
      ph =
        '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6) + '-' + ph.substring(6, 10);
    }

    this.setState({
      phone: ph,
    });
  }

  onKeyPress(e) {
    let ph = e.target.value.replace(/\D/g, '').substring(0, 10);

    let deleteKey = e.key === 'Backspace';
    let len = parseInt(ph.length);

    if (len < 3) {
      ph = '(' + ph;
    } else if (len === 3) {
      ph = '(' + ph + (deleteKey ? '' : ') ');
    } else if (len < 6) {
      ph = '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6);
    } else if (len === 6) {
      ph = '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6) + (deleteKey ? '' : '-');
    } else {
      ph =
        '(' + ph.substring(0, 3) + ') ' + ph.substring(3, 6) + '-' + ph.substring(6, 10);
    }

    this.setState({
      phone: ph,
    });
  }

  updateInsurance(e) {
    e.preventDefault();

    this.setState(
      {
        insurance: '',
        selectedOption: null,
      },
      () => {
        this.setState(this.state);
      },
    );
  }

  selectionChanged = (type) => (ev) => {
    this.setState({ [type]: ev.target.value });
  };

  dropdownChanged = (type) => (ev) => {
    this.setState({ [type]: ev.label });
  };

  updateReturningInsurance(e) {
    e.preventDefault();

    this.setState({
      hasInsurance: '',
      insurance_change: true,
      insurance: '',
      selectedOption: null,
      returning: 'returningUpdate',
    });
  }

  doNotUpdateReturningInsurance(e) {
    e.preventDefault();

    this.setState({
      hasInsurance: 'Yes',
      insurance_change: false,
      insurance: 'No',
      selectedOption: 'already provided',
      returning: '',
    });

    this.scrollToBottom();
  }

  createCookieInHour = (cookieName, cookieValue, hourToExpire) => {
    let date = new Date();
    date.setTime(date.getTime() + hourToExpire * cookieExpiration);
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + date.toGMTString();
  };

  buttonSelected = (selectedButton) => (ev) => {
    if (this.state.insurance === selectedButton) {
      return;
    }
    this.setState({
      insurance: selectedButton,
    });

    if (selectedButton === 'Yes') {
      this.setState({
        hasInsurance: selectedButton,
        selectedOption: null,
        showInsuranceSelection: true,
        showNoInsuranceMessage: false,
      });
    } else {
      this.setState({
        hasInsurance: selectedButton,
        selectedOption: 'already provided',
        showInsuranceSelection: false,
        showNoInsuranceMessage: true,
        subscriber_id: '',
      });
    }

    this.scrollToBottom();
  };

  restoreStateFromURL() {
    // Check if we're returning from a 3DS redirect
    const urlParams = new URLSearchParams(window.location.search);
    const encodedState = urlParams.get('state');

    if (encodedState) {
      try {
        const osState = JSON.parse(atob(encodedState));

        // Restore session storage
        if (osState.appointmentId) {
          window.sessionStorage.setItem('appointmentId', osState.appointmentId);
        }
        if (osState.providerId) {
          window.sessionStorage.setItem('providerId', osState.providerId);
        }
        if (osState.locationId) {
          window.sessionStorage.setItem('locationId', osState.locationId);
        }
        if (osState.selectedAppointment) {
          window.sessionStorage.setItem(
            'selectedAppointment',
            osState.selectedAppointment,
          );
        }
        if (osState.patientType) {
          window.sessionStorage.setItem('patientType', osState.patientType);
        }
        if (osState.currentPage) {
          window.sessionStorage.setItem('currentPage', osState.currentPage);
        }

        // Clean up URL by removing the state parameter
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      } catch (error) {
        console.error('Failed to restore state from URL:', error);
      }
    }
  }

  handleCardDataSync({ cardNumber, expMonth, expYear, ccAgree }) {
    this.ccAgree = ccAgree;
  }

  clearPaymentError = () => {
    if (this.state.paymentError) {
      this.setState({
        paymentError: null,
        paymentIntentId: null,
        setupIntentId: null,
      });
    }
  };

  isValidName = (value) => {
    const trimmed = (value || '').trim();
    return /[a-zA-Z]/.test(trimmed) && !/[0-9]/.test(trimmed);
  };

  validatePatientInput = () => {
    const { fname, lname, email } = this.state;
    if (!this.isValidName(fname)) {
      return { field: 'fname', message: 'Please enter a valid first name' };
    }
    if (!this.isValidName(lname)) {
      return { field: 'lname', message: 'Please enter a valid last name' };
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim())) {
      return { field: 'email', message: 'Please enter a valid email address' };
    }
    return null;
  };

  goToCreateError = () => {
    window.sessionStorage.removeItem('created');
    if (this.props.match.params.analytics !== undefined) {
      this.props.history.push(
        `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
      );
    } else {
      this.props.history.push(`/${this.props.match.params.id}/10`);
    }
  };

  handleStripeAuthentication = async ({
    clientSecret,
    intentType,
    paymentIntentId,
    setupIntentId,
  }) => {
    if (!this.stripe) {
      Sentry.captureMessage('Stripe not initialized for authentication', {
        level: 'error',
        tags: { component: 'ScheduleAppointment', method: 'handleStripeAuthentication' },
        extra: { clientId: this.getClientId() },
      });
      this.setState({
        loading: false,
        paymentError: 'Payment system not ready. Please refresh and try again.',
      });
      return;
    }

    try {
      this.setState({
        scaInProgress: true,
        scaClientSecret: clientSecret,
        scaIntentType: intentType,
        paymentIntentId,
        setupIntentId,
        paymentError: null,
      });

      const { error } = await this.stripe.handleNextAction({
        clientSecret,
      });

      if (error) {
        Sentry.captureException(error, {
          tags: {
            component: 'ScheduleAppointment',
            method: 'handleStripeAuthentication',
          },
          extra: {
            clientId: this.getClientId(),
            intentType,
            paymentIntentId,
            setupIntentId,
          },
        });
        this.setState({
          scaInProgress: false,
          loading: false,
          paymentError: error.message || 'Authentication failed. Please try again.',
        });
        return;
      }

      await this.checkIntentStatus(clientSecret, intentType);
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'ScheduleAppointment', method: 'handleStripeAuthentication' },
        extra: {
          clientId: this.getClientId(),
          intentType,
          paymentIntentId,
          setupIntentId,
        },
      });
      this.setState({
        scaInProgress: false,
        loading: false,
        paymentError: 'Authentication failed. Please try again.',
      });
    }
  };

  async handle3DSAuthentication(response) {
    const { clientSecret, paymentIntentId, setupIntentId } = response;

    if (!this.stripe) {
      Sentry.captureMessage('Stripe not initialized for 3DS authentication', {
        level: 'error',
        tags: { component: 'ScheduleAppointment', method: 'handle3DSAuthentication' },
        extra: { clientId: this.getClientId() },
      });
      alert('Payment system not initialized. Please refresh and try again.');
      return;
    }

    try {
      this.setState({ loading: true });

      if (paymentIntentId) {
        await confirmPayment(this.stripe, clientSecret, paymentIntentId);
      } else if (setupIntentId) {
        await confirmSetup(this.stripe, clientSecret, setupIntentId);
      } else {
        throw new Error('Missing payment or setup intent ID');
      }

      // Re-submit appointment with authenticated payment method
      const appointmentData = this.getAppointmentData();
      if (paymentIntentId) {
        appointmentData.paymentIntentId = paymentIntentId;
      } else if (setupIntentId) {
        appointmentData.setupIntentId = setupIntentId;
      }

      // Remove confirmation token since we're now using the confirmed intent
      delete appointmentData.confirmationTokenId;

      await this.props.createAppointment(appointmentData);

      window.sessionStorage.setItem('created', this.props.appointments);
      this.setState({ loading: false });
      window.sessionStorage.removeItem('backPage');
      window.sessionStorage.setItem('currentPage', 9);

      if (this.props.match.params.analytics !== undefined) {
        this.props.history.push(
          `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
        );
      } else {
        this.props.history.push(`/${this.props.match.params.id}/10`);
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'ScheduleAppointment', method: 'handle3DSAuthentication' },
        extra: { clientId: this.getClientId(), paymentIntentId, setupIntentId },
      });

      this.setState({ loading: false });

      let errorMessage = 'Payment authentication failed. Please try again.';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      alert(errorMessage);
    }
  }

  checkIntentStatus = async (clientSecret, intentType) => {
    try {
      let result;
      if (intentType === 'payment') {
        result = await this.stripe.retrievePaymentIntent(clientSecret);
      } else {
        result = await this.stripe.retrieveSetupIntent(clientSecret);
      }

      const intent = result.paymentIntent || result.setupIntent;

      this.setState({
        scaInProgress: false,
        loading: false,
        scaResult: {
          status: intent.status,
          intentType,
          clientSecret,
        },
      });

      this.handleScaCompletion(intent.status, intentType);
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'ScheduleAppointment', method: 'checkIntentStatus' },
        extra: { clientId: this.getClientId(), intentType },
      });
      this.setState({
        scaInProgress: false,
        loading: false,
        paymentError: 'Unable to verify payment status. Please contact support.',
      });
    }
  };

  handleScaCompletion = (status, intentType) => {
    switch (status) {
      case 'succeeded':
        this.setState({
          scaResult: {
            ...this.state.scaResult,
            finalStatus: 'success',
            message:
              'Payment authentication successful! Your appointment is being finalized.',
          },
        });
        setTimeout(() => {
          if (this.props.match.params.analytics !== undefined) {
            this.props.history.push(
              `/${this.props.match.params.id}/${this.props.match.params.analytics}/10`,
            );
          } else {
            this.props.history.push(`/${this.props.match.params.id}/10`);
          }
        }, 2000);
        break;

      case 'processing':
      case 'requires_capture':
        this.setState({
          scaResult: {
            ...this.state.scaResult,
            finalStatus: 'pending',
            message:
              'Payment is still processing. Your appointment will be finalized when the payment is complete.',
          },
        });
        break;

      case 'requires_payment_method':
      case 'canceled':
        this.setState({
          scaResult: null,
          scaInProgress: false,
          loading: false,
          paymentError:
            'Payment authentication was not completed. Please try again with updated payment information.',
        });
        break;

      default:
        // Unknown status
        this.setState({
          scaResult: {
            ...this.state.scaResult,
            finalStatus: 'error',
            message: `Payment status: ${status}. Please contact support if your appointment is not confirmed.`,
          },
        });
    }
  };

  getAppointmentData() {
    // Helper method to rebuild appointment data for re-submission
    const qAs = [];
    const appointmentId = window.sessionStorage.appointmentId;
    const questions =
      this.props.config.questions !== undefined ? this.props.config.questions : [];

    questions.forEach((el) => {
      if (el.active && el.appointment_types.includes(parseInt(appointmentId))) {
        const found = document.getElementById(el.id);
        if (found) {
          let value = '';
          if (el.type === 'select') {
            value = found.options[found.selectedIndex].text;
          } else {
            value = found.value;
          }
          qAs.push({
            question: el.question,
            answer: value,
            id: el.id,
            type: el.type,
          });
        }
      }
    });

    let scheduleApp = JSON.parse(window.sessionStorage.selectedAppointment);
    let providerId = window.sessionStorage.providerId;
    let client;

    if (window.sessionStorage.locationId) {
      client = window.sessionStorage.locationId;
    } else {
      client = 0;
    }

    let insurance;
    if (
      this.state.hasInsurance === 'Yes' &&
      this.state.selectedOption.label &&
      this.state.selectedOption.label !== 'Other'
    ) {
      insurance = this.state.selectedOption.label;
    } else {
      insurance = 'No';
    }

    let number = this.state.phone.replace(/[^\d]/g, '');

    return {
      client: client,
      fname: this.state.fname,
      lname: this.state.lname,
      email: this.state.email,
      dob: this.state.dob,
      phone: number,
      appointment_id: appointmentId,
      appointment_date: scheduleApp.date,
      appointment_time: scheduleApp.starttime,
      operatory: scheduleApp.operatory,
      provider_id: providerId,
      returning: this.state.returning,
      insurance: insurance,
      insuranceChange: this.state.insurance_change,
      language: getFullLanguageName(),
      subscriber_id: this.state.subscriber_id !== '' ? this.state.subscriber_id : '0',
      tracking: this.props.match.params.analytics,
      qas: qAs,
      guarantor: this.state.guarantor,
      liineSessionId: window.sessionStorage.getItem('liineSessionId'),
      appointmentName: window.sessionStorage.getItem('appointmentName'),
      merchant: this.state.merchant,
    };
  }

  render() {
    const { t } = this.props;
    const currentLanguage = i18n.language;

    const appointmentIndex = this.props.config.appointments.findIndex(
      (appointment) =>
        parseInt(appointment.appointment_id) ===
        parseInt(window.sessionStorage.appointmentId),
    );
    const appointment = this.props.config.appointments[appointmentIndex];

    window.sessionStorage.setItem('confirmedAppt', JSON.stringify(appointment));
    var questions =
      this.props.config.questions !== undefined ? this.props.config.questions : [];

    questions = questions.filter((el) => {
      return (
        !el.enable_appt_types ||
        (el.enable_appt_types && el.appointmentTypes.includes(appointment.appointment_id))
      );
    });
    const scroll = document.getElementsByClassName('scheduleAppointmentContainer');

    if (this.state.hasInsurance === 'Yes') {
      if (
        window.innerHeight > 728 &&
        window.innerHeight < 890 &&
        JSON.parse(window.sessionStorage.phoneType)
      ) {
        $(scroll).attr('style', 'margin-top: 10%');
      } else {
        $(scroll).attr('style', 'margin-top: 0% !important');
        $(scroll).attr('style', 'padding-top: 0% !important');
      }
    } else {
      $(scroll).attr('style', 'margin-top: 0% !important');
      $(scroll).attr('style', 'padding-top: 0% !important');
    }

    const backButton = document.getElementsByClassName('backButton');

    if (this.state.loading) {
      $(backButton).addClass('hideButton');
    } else {
      $(backButton).removeClass('hideButton');
    }

    const { selectedOption } = this.state;

    const { fname, lname, dob, email, phone, insurance, subscriber_id } = this.state;

    const myCookie = this.getCookie(
      this.state.guarantor ? this.state.guarantor.phone : phone,
    );

    let selectedAppointment;

    if (window.sessionStorage.selectedAppointment) {
      selectedAppointment = JSON.parse(window.sessionStorage.selectedAppointment);
    }

    if (typeof selectedAppointment === 'object' && selectedAppointment.length > 0) {
      selectedAppointment = selectedAppointment[0];
    }

    let provider;
    let providerId;
    let providerIndex;

    if (parseInt(window.sessionStorage.providerId) !== 0) {
      providerIndex = this.props.config.providers.findIndex(
        (provider) =>
          parseInt(provider.provider_assoc) ===
          parseInt(window.sessionStorage.providerId),
      );
      provider = this.props.config.providers[providerIndex];
    } else {
      // For first available appointments
      // check if providerId has been added to selectedAppointment (available in client-side build version > 4.13.2)
      // selectedAppointment will be either an object or an Array with 1 appointment object
      const selectedAppointment = JSON.parse(window.sessionStorage.selectedAppointment);
      const apptProvider = Array.isArray(selectedAppointment)
        ? selectedAppointment[0].providerId
        : selectedAppointment.providerId;
      if (apptProvider) {
        providerIndex = this.props.config.providers.findIndex(
          (provider) => parseInt(provider.provider_assoc) === parseInt(apptProvider),
        );
        provider = this.props.config.providers[providerIndex];
      }
    }

    const { practicePhone } = this.props.config;

    const activeInsuranceOptions = this.props.config.insurance[0].active;
    let inNetworkInsuranceOptions = this.props.config.insurance[1].inNetwork;

    // filter out inNetwork Insurance options if selected provider has exclusions
    if (provider?.insexclude) {
      inNetworkInsuranceOptions = inNetworkInsuranceOptions.filter(
        (opt) => !provider.insexclude.includes(`${opt.value}`),
      );
    }

    let allInsuranceOptions = _.unionBy(
      activeInsuranceOptions,
      inNetworkInsuranceOptions,
      'label',
    );
    allInsuranceOptions.push({ value: 0, label: 'Other' });

    const insuranceMessages = this.props.config.messages;

    let regex = '{{practicephone}}';
    let providerRegex = '{{provider}}';
    let takesRegex = 'takes';
    let insuranceVerbLinkRegex = ' is in ';

    let insuranceMessage;
    let insuranceMsgProvider;
    let insuranceTakesWord;
    let insuranceVerbLink;

    if (provider) {
      insuranceMsgProvider = provider.name;
      insuranceTakesWord = 'takes';
      insuranceVerbLink = ' is in ';
    } else {
      insuranceMsgProvider = 'We';
      insuranceTakesWord = 'take';
      insuranceVerbLink = ' are in ';
    }

    if (this.state.showNoInsuranceMessage) {
      insuranceMessage = (
        <div
          id="insuranceId"
          ref={(el) => {
            this.el = el;
          }}
          className="insuranceMessage"
        >
          {(() => {
            const filteredMessage = this.filterValue(
              insuranceMessages,
              'type',
              'noinsurance',
            );
            return currentLanguage === 'es' && filteredMessage.message_translated
              ? filteredMessage.message_translated
                  .replace(regex, practicePhone)
                  .replace(providerRegex, insuranceMsgProvider)
              : filteredMessage.message
                  .replace(regex, practicePhone)
                  .replace(providerRegex, insuranceMsgProvider)
                  .replace(takesRegex, insuranceTakesWord)
                  .replace(insuranceVerbLinkRegex, insuranceVerbLink);
          })()}
        </div>
      );
    } else {
      if (this.state.showInsuranceMessage) {
        if (_.find(inNetworkInsuranceOptions, this.state.selectedOption)) {
          insuranceMessage = (
            <div
              id="insuranceId"
              ref={(el) => {
                this.el = el;
              }}
              className="insuranceMessage"
            >
              {(() => {
                const filteredMessage = this.filterValue(
                  insuranceMessages,
                  'type',
                  'innetwork',
                );
                return currentLanguage === 'es' && filteredMessage.message_translated
                  ? filteredMessage.message_translated
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                  : filteredMessage.message
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                      .replace(takesRegex, insuranceTakesWord)
                      .replace(insuranceVerbLinkRegex, insuranceVerbLink);
              })()}
            </div>
          );
        } else if (_.find(activeInsuranceOptions, this.state.selectedOption)) {
          insuranceMessage = (
            <div
              id="insuranceId"
              ref={(el) => {
                this.el = el;
              }}
              className="insuranceMessage"
            >
              {(() => {
                const filteredMessage = this.filterValue(
                  insuranceMessages,
                  'type',
                  'outnetwork',
                );
                return currentLanguage === 'es' && filteredMessage.message_translated
                  ? filteredMessage.message_translated
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                  : filteredMessage.message
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                      .replace(takesRegex, insuranceTakesWord)
                      .replace(insuranceVerbLinkRegex, insuranceVerbLink);
              })()}
            </div>
          );
        } else {
          insuranceMessage = (
            <div
              id="insuranceId"
              ref={(el) => {
                this.el = el;
              }}
              className="insuranceMessage"
            >
              {(() => {
                const filteredMessage = this.filterValue(
                  insuranceMessages,
                  'type',
                  'other',
                );
                return currentLanguage === 'es' && filteredMessage.message_translated
                  ? filteredMessage.message_translated
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                  : filteredMessage.message
                      .replace(regex, practicePhone)
                      .replace(providerRegex, insuranceMsgProvider)
                      .replace(takesRegex, insuranceTakesWord)
                      .replace(insuranceVerbLinkRegex, insuranceVerbLink);
              })()}
            </div>
          );
        }
      } else {
        insuranceMessage = (
          <div
            id="insuranceId"
            ref={(el) => {
              this.el = el;
            }}
            className="insuranceMessage"
          ></div>
        );
      }
    }

    let insuranceSelection;

    if (this.state.showInsuranceSelection) {
      insuranceSelection = (
        <div className="row justify-content-center">
          <div className="insuranceSelection col-sm-12 col-md-8">
            <Select
              maxMenuHeight={225}
              isClearable={false}
              isSearchable={false}
              // Darken the control border to meet WCAG 1.4.11 (a11y SHO_108).
              theme={(theme) => ({
                ...theme,
                colors: { ...theme.colors, neutral20: '#595959', neutral30: '#595959' },
              })}
              aria-label={currentLanguage === 'es' ? 'Proveedor de seguro dental' : 'Dental insurance provider'}
              onChange={this.handleInsurance}
              components={{ SingleValue }}
              options={allInsuranceOptions}
              placeholder={currentLanguage === 'es' ? 'Seleccionar...' : 'Select...'}
            />
          </div>
        </div>
      );
    }

    let ins = false;

    // checks required fields are filled out to disable/enable submit button
    if (
      insurance.length &&
      selectedOption?.label !== 'Other' &&
      subscriber_id.length > 1
    ) {
      ins = true;
    } else if (
      selectedOption?.label === 'Other' &&
      this.state.insuranceOther !== 'No' &&
      this.state.insuranceOther.length > 1 &&
      subscriber_id.length > 1
    ) {
      ins = true;
    } else if (insurance === 'No' && selectedOption !== null) {
      ins = true;
    }

    let sendCodeAlert;
    if (myCookie && myCookie === 'approved') {
      sendCodeAlert = (
        <div className={`col col-12 codeAlert ${this.state.showCodeAlert}`}>
          {t('You have already confirmed your identity')}
        </div>
      );
    } else {
      sendCodeAlert = (
        <div className={`col col-12 codeAlert ${this.state.showCodeAlert}`}>
          {t('We’ll text you a 6-digit code to confirm this appointment')}.
        </div>
      );
    }

    let insuranceDiv;
    let insuranceFillField;
    let subscriberFillField;
    const questionsDiv = [];
    const questionsPlaces = [];
    const topQuestions = [];
    const returning = this.state.returning;

    if (returning !== 'new') {
      questions.forEach((ele, i) => {
        if (ele.type === 1 && ele.condition === 3) {
          questionsPlaces.push(ele);
          topQuestions.push(
            <TextQuestion
              dob={this.state.dob}
              onChange={this.update(`question-${ele.id}`)}
              value={this.state[`${ele}`]}
              refs={`textInput${ele.id}`}
              disabled={this.state.show}
              key={i}
              data={ele}
            />,
          );
        } else if (ele.type === 2 && ele.condition === 3) {
          questionsPlaces.push(ele);
          topQuestions.push(
            <RadioQuestion
              dob={this.state.dob}
              state={this.state}
              onChange={this.selectionChanged(`question-${ele.id}`)}
              key={i}
              data={ele}
            />,
          );
        } else if (ele.type === 3 && ele.condition === 3) {
          questionsPlaces.push(ele);
          topQuestions.push(
            <DropdownQuestion
              dob={this.state.dob}
              onChange={this.dropdownChanged(`question-${ele.id}`)}
              key={i}
              data={ele}
            />,
          );
        }
      });
    }

    if (returning === 'returning' || returning === '') {
      insuranceDiv = (
        <div className="insContainer">
          <div className="insuranceDescription">
            {t('Has your insurance changed since you last visited us')}?
          </div>

          <Button
            color={this.props.config.color}
            className="insurance updateInsurance"
            type="button"
            onClick={this.updateReturningInsurance}
          >
            {t('Yes')}
          </Button>
          <Button
            color={this.props.config.color}
            aria-pressed={'Yes' === this.state.hasInsurance}
            className={`insurance updateInsurance ${
              'Yes' === this.state.hasInsurance ? 'selected' : ''
            }`}
            type="button"
            onClick={this.doNotUpdateReturningInsurance}
          >
            {t('No')}
          </Button>
        </div>
      );
    } else {
      if (
        this.state.insurance &&
        this.state.insurance === 'No' &&
        returning === 'returning'
      ) {
        // returning that do not have insurance

        insuranceDiv = (
          <div className="insContainer">
            <div className="insuranceDescription">
              {t('Our records show that you do not have insurance')}.
            </div>

            <Button
              color={this.props.config.color}
              className="insurance updateInsurance"
              type="button"
              onClick={this.updateInsurance}
            >
              {t('Update')}
            </Button>
          </div>
        );
      } else if (
        this.state.insurance &&
        this.state.insurance !== 'No' &&
        returning === 'returning'
      ) {
        // returning that have insurance

        questions.forEach((ele, i) => {
          if (ele.type === 1 && ele.condition === 6) {
            questionsPlaces.push(ele);
            questionsDiv.push(
              <TextQuestion
                dob={this.state.dob}
                onChange={this.update(`question-${ele.id}`)}
                value={this.state[`${ele}`]}
                refs={`textInput${ele.id}`}
                disabled={this.state.show}
                key={i}
                data={ele}
              />,
            );
          } else if (ele.type === 2 && ele.condition === 6) {
            questionsPlaces.push(ele);
            questionsDiv.push(
              <RadioQuestion
                dob={this.state.dob}
                state={this.state}
                onChange={this.selectionChanged(`question-${ele.id}`)}
                key={i}
                data={ele}
              />,
            );
          } else if (ele.type === 3 && ele.condition === 6) {
            questionsPlaces.push(ele);
            questionsDiv.push(
              <DropdownQuestion
                dob={this.state.dob}
                onChange={this.dropdownChanged(`question-${ele.id}`)}
                key={i}
                data={ele}
              />,
            );
          }
        });

        insuranceDiv = (
          <div className="insContainer">
            <div className="insuranceDescription">
              {t('Our records show that you have {{insuranceLabel}} insurance', {
                insuranceLabel:
                  this.state.insurance !== 'Yes'
                    ? this.state.insurance
                    : this.state.selectedOption.label,
              })}
              .
            </div>

            <Button
              color={this.props.config.color}
              className="insurance updateInsurance"
              type="button"
              onClick={this.updateInsurance}
            >
              {t('Update')}
            </Button>
          </div>
        );
      } else {
        // new that have insurance
        if (this.state.insurance === 'Yes' && returning !== 'returningUpdate') {
          questions.forEach((ele, i) => {
            if (ele.type === 1 && ele.condition === 4) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <TextQuestion
                  dob={this.state.dob}
                  onChange={this.update(`question-${ele.id}`)}
                  value={this.state[`${ele}`]}
                  refs={`textInput${ele.id}`}
                  disabled={this.state.show}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 2 && ele.condition === 4) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <RadioQuestion
                  dob={this.state.dob}
                  state={this.state}
                  onChange={this.selectionChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 3 && ele.condition === 4) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <DropdownQuestion
                  dob={this.state.dob}
                  onChange={this.dropdownChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            }
          });
        } else if (this.state.insurance === 'No' && returning !== 'returningUpdate') {
          // new that do not have insurance
          questions.forEach((ele, i) => {
            if (ele.type === 1 && ele.condition === 5) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <TextQuestion
                  dob={this.state.dob}
                  onChange={this.update(`question-${ele.id}`)}
                  value={this.state[`${ele}`]}
                  handleKeyPress={(event) =>
                    this.handleKeyPress(`textInput${ele.id}`, event)
                  }
                  refs={`textInput${ele.id}`}
                  onKeyDown={this.onKeyPress}
                  disabled={this.state.show}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 2 && ele.condition === 5) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <RadioQuestion
                  dob={this.state.dob}
                  state={this.state}
                  onChange={this.selectionChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 3 && ele.condition === 5) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <DropdownQuestion
                  dob={this.state.dob}
                  onChange={this.dropdownChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            }
          });
        }

        if (returning === 'new') {
          questions.forEach((ele, i) => {
            if (ele.type === 1 && ele.condition === 2) {
              questionsPlaces.push(ele);
              topQuestions.push(
                <TextQuestion
                  dob={this.state.dob}
                  onChange={this.update(`question-${ele.id}`)}
                  value={this.state[`${ele}`]}
                  refs={`textInput${ele.id}`}
                  disabled={this.state.show}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 2 && ele.condition === 2) {
              questionsPlaces.push(ele);
              topQuestions.push(
                <RadioQuestion
                  dob={this.state.dob}
                  state={this.state}
                  onChange={this.selectionChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 3 && ele.condition === 2) {
              questionsPlaces.push(ele);
              topQuestions.push(
                <DropdownQuestion
                  dob={this.state.dob}
                  onChange={this.dropdownChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            }
          });
        }

        if (returning === 'returningUpdate' && this.state.insurance === 'Yes') {
          questions.forEach((ele, i) => {
            if (ele.type === 1 && ele.condition === 6) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <TextQuestion
                  dob={this.state.dob}
                  onChange={this.update(`question-${ele.id}`)}
                  value={this.state[`${ele}`]}
                  refs={`textInput${ele.id}`}
                  disabled={this.state.show}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 2 && ele.condition === 6) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <RadioQuestion
                  dob={this.state.dob}
                  state={this.state}
                  onChange={this.selectionChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 3 && ele.condition === 6) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <DropdownQuestion
                  dob={this.state.dob}
                  onChange={this.dropdownChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            }
          });
        }

        if (returning === 'returningUpdate' && this.state.insurance === 'No') {
          questions.forEach((ele, i) => {
            if (ele.type === 1 && ele.condition === 7) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <TextQuestion
                  dob={this.state.dob}
                  onChange={this.update(`question-${ele.id}`)}
                  value={this.state[`${ele}`]}
                  refs={`textInput${ele.id}`}
                  disabled={this.state.show}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 2 && ele.condition === 7) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <RadioQuestion
                  dob={this.state.dob}
                  state={this.state}
                  onChange={this.selectionChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            } else if (ele.type === 3 && ele.condition === 7) {
              questionsPlaces.push(ele);
              questionsDiv.push(
                <DropdownQuestion
                  dob={this.state.dob}
                  onChange={this.dropdownChanged(`question-${ele.id}`)}
                  key={i}
                  data={ele}
                />,
              );
            }
          });
        }

        if (selectedOption !== null && selectedOption.label === 'Other') {
          insuranceFillField = (
            <div className="row justify-content-center">
              <div className="insuranceInput field col-sm-12 col-md-8">
                <input
                  disabled={this.state.show}
                  maxLength="75"
                  onChange={this.update('insuranceOther')}
                  type="name"
                  className="form-control"
                  id="insurance-provider-other"
                  aria-label={t('Insurance Provider')}
                  placeholder={`${t('Insurance Provider')}*`}
                />
              </div>
            </div>
          );

          subscriberFillField = (
            <div className="row justify-content-center">
              <div className="subscriberInput field col-sm-12 col-md-8">
                <input
                  disabled={this.state.show}
                  onChange={this.update('subscriber_id')}
                  type="name"
                  className="form-control"
                  id="subscriber-id"
                  aria-label={t('Subscriber ID')}
                  placeholder={`${t('Subscriber ID')} #*`}
                />
              </div>
            </div>
          );
        } else if (
          selectedOption !== null &&
          allInsuranceOptions.includes(selectedOption)
        ) {
          subscriberFillField = (
            <div className="row justify-content-center">
              <div className="subscriberInput field col-sm-12 col-md-8">
                <input
                  disabled={this.state.show}
                  onChange={this.update('subscriber_id')}
                  type="name"
                  className="form-control"
                  id="subscriber-id-existing"
                  aria-label={t('Subscriber ID')}
                  placeholder={`${t('Enter Subscriber ID')} #*`}
                />
              </div>
            </div>
          );
        } else {
          insuranceFillField = <div className="row justify-content-center"></div>;
        }

        insuranceDiv = (
          <div className="insContainer">
            <div className="insuranceDescription">
              {t('Do you have dental insurance')}?
            </div>
            {['No', 'Yes'].map((key) => (
              <Button
                color={this.props.config.color}
                disabled={this.state.show}
                aria-pressed={key === this.state.hasInsurance}
                className={`insurance ${
                  key === this.state.hasInsurance ? 'selected' : ''
                }`}
                type="button"
                key={key}
                onClick={this.buttonSelected(key)}
              >
                {t(key)}
              </Button>
            ))}
          </div>
        );
      }
    }

    let providerName = '';

    if (appointment && appointment.provider_select !== 0) {
      if (providerId && providerId > 0) {
        providerName = t('with {{name}}', { name: provider.name });
      } else {
        providerName = t('at {{practiceName}}', {
          practiceName: this.props.config.practiceName,
        });
      }
    } else {
      providerName = t('at {{practiceName}}', {
        practiceName: this.props.config.practiceName,
      });
    }

    // all patients
    questions.forEach((ele, i) => {
      if (ele.type === 1 && ele.condition === 1) {
        questionsPlaces.push(ele);
        topQuestions.push(
          <TextQuestion
            dob={this.state.dob}
            onChange={this.update(`question-${ele.id}`)}
            value={this.state[`${ele}`]}
            refs={`textInput${ele.id}`}
            disabled={this.state.show}
            key={i}
            data={ele}
          />,
        );
      } else if (ele.type === 2 && ele.condition === 1) {
        questionsPlaces.push(ele);
        topQuestions.push(
          <RadioQuestion
            dob={this.state.dob}
            state={this.state}
            onChange={this.selectionChanged(`question-${ele.id}`)}
            key={i}
            data={ele}
          />,
        );
      } else if (ele.type === 3 && ele.condition === 1) {
        questionsPlaces.push(ele);
        topQuestions.push(
          <DropdownQuestion
            dob={this.state.dob}
            onChange={this.dropdownChanged(`question-${ele.id}`)}
            key={i}
            data={ele}
          />,
        );
      }
    });

    var answeredRequired = true;

    questionsPlaces.forEach((el) => {
      if (
        (el.required === 1 && this.state[`question-${el.id}`] === undefined) ||
        (el.required === 1 && this.state[`question-${el.id}`] === '')
      ) {
        if (el.agerestrict !== '') {
          const restrictDob = moment(this.state.dob).format('YYYY-MM-DD');
          if (restrictDob !== 'Invalid date') {
            var a = moment();
            var diff = a.diff(restrictDob, 'years');

            if (diff <= el.agerestrict) {
              if (
                this.state[`question-${el.id}`] === '' ||
                this.state[`question-${el.id}`] === undefined
              ) {
                answeredRequired = false;
              }
            }
          }
        } else {
          answeredRequired = false;
        }
      }
    });

    let ph = phone.replace(/\D/g, '');

    let len = parseInt(ph.length);

    let isEnabled =
      fname.length > 0 &&
      lname.length > 0 &&
      email.length > 0 &&
      dob.length > 0 &&
      len === 10 &&
      answeredRequired;

    if (!this.props.config.hideInsurance) {
      isEnabled = isEnabled && insurance.length > 1 && ins;
    }

    // Only gate on CardConnect token when payment is actually required
    if (
      this.state.merchant === 'cardconnect' &&
      this.state.paymentsActive &&
      this.state.ccApptIncluded &&
      this.state.ccHandleMode &&
      !this.state.ccTokenReady
    ) {
      isEnabled = false;
    }

    if (
      this.state.merchant === 'stripe' &&
      this.state.paymentsActive &&
      this.state.ccApptIncluded &&
      this.state.ccHandleMode &&
      !this.state.stripeReady
    ) {
      isEnabled = false;
    }

    const isFormDisabled =
      this.state.show ||
      this.state.scaInProgress ||
      (this.state.scaResult && this.state.scaResult.finalStatus === 'success');

    const showGuarModal = this.state.showGuarantorModal;
    return (
      <div className="scheduleAppointmentContainer">
        <div
          ref={(el) => {
            this.el = el;
          }}
          className={`blurry row justify-content-center ${showGuarModal ? 'blur' : ''}`}
        >
          <div className="col col-11 schedule_appointment_header">
            <FlexIcon class="scheduleApptImage" icon={appointment.icon} />

            <div className="appointmentHead">
              {currentLanguage === 'es' && appointment.name_translated
                ? appointment.name_translated
                : appointment.name}
            </div>

            <div className="appointmentHeadLength">
              {appointment.length} {t('minutes')}
            </div>

            <div className="appointmentTimes">
              {t('{{date}}, {{month}} {{day}} at {{time}}', {
                date: t(moment(selectedAppointment.date).format('dddd')),
                month: t(moment(selectedAppointment.date).format('MMMM')),
                day: moment(selectedAppointment.date).format('D'),
                time: moment(selectedAppointment.starttime, 'hh:mm:ss')
                  .format('h:mm a')
                  .replace(/(a|p)(m)/, '$1.$2.'),
              })}
            </div>
            <div className="schedApptProvider">{providerName}</div>
          </div>

          {!this.state.loading ? (
            <>
              {this.state.submitError && (
                <div className="col col-11" style={{ marginBottom: '15px' }}>
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.submitError)}
                  </div>
                </div>
              )}
              <p className="col col-11 requiredFieldNote" style={{ textAlign: 'left', marginBottom: '10px' }}>
                {t('* indicates a required field')}
              </p>
              <div
                id="firstInput"
                ref={(el) => {
                  this.el = el;
                }}
                className="field col-sm-10 col-md-4"
              >
                <input
                  onKeyPress={(event) => this.handleKeyPress('fname', event)}
                  ref={this.inputRefs.fname}
                  onFocus={this.scrollToFirst}
                  disabled={isFormDisabled}
                  onChange={this.update('fname')}
                  type="name"
                  className={`form-control ${
                    this.state.submitErrorField === 'fname' ? 'invalid' : ''
                  }`}
                  id="fname"
                  aria-label={t('Patient First Name')}
                  aria-required="true"
                  placeholder={t('Patient First Name')}
                />
              </div>
              <div
                id="lastInput"
                ref={(el) => {
                  this.el = el;
                }}
                className="field col-sm-10 col-md-4"
              >
                <input
                  onKeyPress={(event) => this.handleKeyPress('lname', event)}
                  ref={this.inputRefs.lname}
                  onFocus={this.scrollToLast}
                  disabled={isFormDisabled}
                  onChange={this.update('lname')}
                  type="name"
                  className={`form-control ${
                    this.state.submitErrorField === 'lname' ? 'invalid' : ''
                  }`}
                  id="lname"
                  aria-label={t('Patient Last Name')}
                  aria-required="true"
                  placeholder={t('Patient Last Name')}
                />
              </div>
              <div
                id="emailInput"
                ref={(el) => {
                  this.el = el;
                }}
                className="field col-sm-10 col-md-8"
              >
                <input
                  onKeyPress={(event) => this.handleKeyPress('email', event)}
                  ref={this.inputRefs.email}
                  onFocus={this.scrollToEmail}
                  disabled={isFormDisabled}
                  onChange={this.handleEmail}
                  type="email"
                  className={`form-control ${
                    this.state.submitErrorField === 'email' || this.state.emailAlert ? 'invalid' : ''
                  }`}
                  id="email"
                  aria-label={t('Email')}
                  aria-required="true"
                  aria-invalid={this.state.emailAlert || this.state.submitErrorField === 'email'}
                  aria-describedby={this.state.emailAlert ? 'email-error' : undefined}
                  placeholder={t('Email')}
                />
                {this.state.emailAlert && (
                  <div className="fieldError" id="email-error" role="alert">
                    <span aria-hidden="true">⚠ </span>
                    {t('Please enter a valid email address.')}
                  </div>
                )}
              </div>

              <div className="field col-sm-10 col-md-8">
                <label className="col col-12 label dobLabel" htmlFor="date-of-birth-month">
                  {t('Patient Date of Birth')}
                </label>
                <div className="dobDiv">
                  <select
                    onKeyPress={(event) => this.handleKeyPress('month', event)}
                    ref={this.inputRefs.month}
                    name="date-of-birth-month"
                    id="date-of-birth-month"
                    aria-label={t('Patient date of birth month')}
                    aria-required="true"
                    aria-invalid={this.state.dobAlert}
                    aria-describedby={this.state.dobAlert ? 'dob-error' : undefined}
                    disabled={this.state.show}
                    onChange={this.handleDob}
                    className={`form-control monthSelect ${
                      this.state.dobAlert ? 'invalid' : ''
                    }`}
                  >
                    <option value="1">{t('January')}</option>
                    <option value="2">{t('February')}</option>
                    <option value="3">{t('March')}</option>
                    <option value="4">{t('April')}</option>
                    <option value="5">{t('May')}</option>
                    <option value="6">{t('June')}</option>
                    <option value="7">{t('July')}</option>
                    <option value="8">{t('August')}</option>
                    <option value="9">{t('September')}</option>
                    <option value="10">{t('October')}</option>
                    <option value="11">{t('November')}</option>
                    <option value="12">{t('December')}</option>
                  </select>

                  <input
                    onKeyPress={(event) => this.handleKeyPress('day', event)}
                    ref={this.inputRefs.day}
                    type="number"
                    name="date-of-birth-day"
                    id="date-of-birth-day"
                    aria-label={t('Patient date of birth day')}
                    aria-required="true"
                    aria-invalid={this.state.dobAlert}
                    aria-describedby={this.state.dobAlert ? 'dob-error' : undefined}
                    disabled={this.state.show}
                    onChange={this.handleDob}
                    className={`form-control dayInput ${
                      this.state.dobAlert ? 'invalid' : ''
                    }`}
                    min="1"
                    max="31"
                    placeholder="DD"
                  />
                  <input
                    onKeyPress={(event) => this.handleKeyPress('year', event)}
                    ref={this.inputRefs.year}
                    type="number"
                    name="date-of-birth-year"
                    id="date-of-birth-year"
                    aria-label={t('Patient date of birth year')}
                    aria-required="true"
                    aria-invalid={this.state.dobAlert}
                    aria-describedby={this.state.dobAlert ? 'dob-error' : undefined}
                    disabled={this.state.show}
                    onChange={this.handleDob}
                    className={`form-control yearInput ${
                      this.state.dobAlert ? 'invalid' : ''
                    }`}
                    min="1900"
                    max="2020"
                    placeholder="YYYY"
                  />
                </div>
                {this.state.dobAlert && (
                  <div className="fieldError" id="dob-error" role="alert">
                    <span aria-hidden="true">⚠ </span>
                    {t('Please enter a valid date of birth.')}
                  </div>
                )}
              </div>

              <div
                id="phoneInput"
                ref={(el) => {
                  this.el = el;
                }}
                className="field col-sm-10 col-md-8"
              >
                <input
                  onKeyPress={(event) => this.handleKeyPress('phone', event)}
                  ref={this.inputRefs.phone}
                  onFocus={this.scrollToPhone}
                  onKeyDown={this.onKeyPress}
                  disabled={this.state.show}
                  value={this.state.phone}
                  onChange={this.handlePhone}
                  className="form-control"
                  placeholder={t('Mobile Number')}
                  aria-label={t('Mobile Number')}
                  aria-required="true"
                  name="mobile"
                  id="mobile"
                  autoComplete="mobile tel"
                />
              </div>

              {sendCodeAlert}

              <hr
                className="field col-8"
                style={{
                  color: '#d3d3d3',
                  backgroundColor: '#d3d3d3',
                }}
              />

              {topQuestions}

              {this.state.ccHandleMode && (
                <div className="payment-wrapper">
                  {this.state.paymentError && (
                    <div
                      className="col col-11 payment-error-container"
                      style={{ marginBottom: '15px' }}
                    >
                      <div className="alert alert-danger" role="alert">
                        <strong>{t('Payment Error')}:</strong> {this.state.paymentError}
                        <br />
                        <small>
                          {t('Please update your payment information and try again.')}
                        </small>
                      </div>
                    </div>
                  )}

                  {this.state.ccHandleMode === 'deposit' && (
                    <h6>
                      {currentLanguage === 'es' && this.state.ccDepositTextTranslated
                        ? this.state.ccDepositTextTranslated
                        : this.state.ccDepositText}
                      <br />
                      <br />
                      {t('Deposit Amount')}: ${this.state.ccDepositAmount}
                    </h6>
                  )}
                  {this.state.ccHandleMode === 'hold' && (
                    <h6>
                      {currentLanguage === 'es' && this.state.ccHoldTextTranslated
                        ? this.state.ccHoldTextTranslated
                        : this.state.ccHoldText}
                    </h6>
                  )}

                  <Disclaimer
                    syncCardData={this.handleCardDataSync}
                    phone={this.props.config.practicePhone}
                    color={this.props.config.color}
                    merchant={this.state.merchant}
                    holdsOrDepositsEnabled={
                      !!(this.state.ccHoldEnabled || this.state.ccDepositEnabled)
                    }
                    practiceName={this.props.config.practiceName}
                    surchargingEnabled={!!this.state.surchargingEnabled}
                    surchargingMaxRate={this.state.surchargingMaxRate}
                  />
                  {this.state.merchant === 'moolah' && (
                    <div
                      className="moolah-payment-iframe"
                      id="moolah-payment-iframe"
                    ></div>
                  )}
                  {this.state.merchant === 'cardconnect' && (
                    <div
                      className="cardconnect-payment-iframe"
                      id="cardconnect-iframe"
                    ></div>
                  )}
                  {this.state.merchant === 'stripe' && (
                    <div className="stripe-payment-container">
                      <StripeAdapter
                        mode={this.state.ccHandleMode === 'deposit' ? 'payment' : 'setup'}
                        amount={
                          this.state.ccHandleMode === 'deposit'
                            ? this.state.ccDepositAmount * 100
                            : undefined
                        }
                        connectedAccountId={this.state.stripeConnectedAccountId}
                        surcharging={this.isSurchargeDepositFlow()}
                        onReady={() => {
                          this.setState({ stripeReady: true });
                        }}
                        onError={(error) => {
                          console.error('Stripe error:', error);
                          this.setState({ stripeReady: false });
                        }}
                        onElementsReady={(elements) => {
                          this.stripeElements = elements;

                          if (
                            !this.state.paymentError ||
                            !this.state.paymentError.includes(
                              'requires additional verification',
                            )
                          ) {
                            this.clearPaymentError();
                          }
                        }}
                        onStripeReady={(stripe) => {
                          this.stripe = stripe;
                        }}
                      />
                    </div>
                  )}
                  {this.state.surchargeDisclosure &&
                    createPortal(
                      <div className="surcharge-modal-overlay" role="presentation">
                        <div
                          className="surcharge-modal"
                          role="dialog"
                          aria-modal="true"
                          aria-label={t('Confirm Payment')}
                        >
                        <p className="surcharge-disclosure-notice">
                          {t(
                            'A {{rate}}% processing fee applies to credit card payments.',
                            {
                              rate: (
                                (this.state.surchargeDisclosure.surcharge /
                                  this.state.surchargeDisclosure.amount) *
                                100
                              ).toFixed(2),
                            },
                          )}
                        </p>
                        <div className="surcharge-breakdown">
                          <div className="surcharge-breakdown-row">
                            <span>{t('Deposit Amount')}</span>
                            <span>
                              $
                              {(
                                this.state.surchargeDisclosure.amount / 100
                              ).toFixed(2)}
                            </span>
                          </div>
                          <div className="surcharge-breakdown-row">
                            <span>{t('Processing fee')}</span>
                            <span>
                              $
                              {(
                                this.state.surchargeDisclosure.surcharge / 100
                              ).toFixed(2)}
                            </span>
                          </div>
                          <div className="surcharge-breakdown-row surcharge-breakdown-total">
                            <span>{t('Total')}</span>
                            <span>
                              $
                              {(
                                this.state.surchargeDisclosure.total / 100
                              ).toFixed(2)}
                            </span>
                          </div>
                        </div>
                        <p className="surcharge-saved-card-notice">
                          {t(
                            'By saving your payment method, you authorize future charges to this card, which may include a surcharge of up to {{rate}}% on credit card transactions, which is not greater than our cost of accepting the card. Payment by credit card is not mandatory. We also accept other forms of payment without applying a surcharge such as debit cards.',
                            {
                              rate: ((Number(this.state.surchargingMaxRate) || 0) * 100)
                                .toFixed(2)
                                .replace(/\.?0+$/, ''),
                            },
                          )}
                        </p>
                        <div className="surcharge-actions">
                          <Button
                            type="button"
                            color={this.props.config.color}
                            hover={this.state.hover}
                            className="scheduleApptButton btn btn-primary"
                            onClick={() => this.handleChangeCard()}
                            disabled={this.state.confirmingSurcharge}
                          >
                            {t('Change Card')}
                          </Button>
                          <ContinueButton
                            type="button"
                            color={this.props.config.color}
                            hover={this.state.hover}
                            className="scheduleApptButton btn btn-primary"
                            onClick={() => this.handleConfirmSurcharge()}
                            disabled={this.state.confirmingSurcharge}
                          >
                            {this.state.confirmingSurcharge
                              ? `${t('Processing')}...`
                              : t('Confirm Payment')}
                          </ContinueButton>
                        </div>
                      </div>
                    </div>,
                    document.body,
                  )}
                </div>
              )}
              {this.state.paymentError && (
                <div className="col col-11 payment-error-container">
                  <div className="alert alert-danger" role="alert">
                    <strong>{t('Payment Error')}:</strong> {this.state.paymentError}
                    <br />
                    <small>
                      {t('Please update your payment information and try again.')}
                    </small>
                  </div>
                </div>
              )}
              {this.state.scaInProgress && (
                <div className="col col-11 sca-status-container">
                  <div className="alert alert-info" role="alert">
                    <div className="d-flex align-items-center">
                      <PulseLoader color={'#0066cc'} size={8} className="me-3" />
                      <div>
                        <strong>{t('Authenticating Payment')}...</strong>
                        <br />
                        <small>
                          {t(
                            'Please complete the authentication process in the popup window.',
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.scaResult && (
                <div className="col col-11 sca-status-container">
                  <div
                    className={`alert ${
                      this.state.scaResult.finalStatus === 'success'
                        ? 'alert-success'
                        : this.state.scaResult.finalStatus === 'pending'
                          ? 'alert-warning'
                          : 'alert-info'
                    }`}
                    role="alert"
                  >
                    <strong>
                      {this.state.scaResult.finalStatus === 'success'
                        ? t('Authentication Successful')
                        : this.state.scaResult.finalStatus === 'pending'
                          ? t('Payment Processing')
                          : t('Payment Status')}
                      :
                    </strong>{' '}
                    {this.state.scaResult.message}
                  </div>
                </div>
              )}
              {this.props.config.hideInsurance ? (
                <div className="col col-11"></div>
              ) : (
                <div className="col col-11 insuranceContainer">
                  {insuranceDiv}

                  {insuranceSelection}

                  {insuranceFillField}

                  {subscriberFillField}

                  {questionsDiv}

                  {insuranceMessage}
                </div>
              )}
              {this.state.guarantor && this.state.scheduleFor === 'someoneElse' ? (
                <div id="guar-sch-btn-container" className="col col-11">
                  <BackButton
                    id="continueButton"
                    color={this.props.config.color}
                    hover={this.state.hover}
                    className="col col-11 scheduleApptButton btn btn-primary"
                    onClick={this.handleShowGuarantorModal}
                  >
                    Back
                  </BackButton>

                  <ContinueButton
                    id="continueButton"
                    color={this.props.config.color}
                    hover={this.state.hover}
                    disabled={
                      !isEnabled ||
                      this.state.submitting ||
                      this.state.show ||
                      !!this.state.surchargeDisclosure ||
                      this.state.scaInProgress ||
                      (this.state.scaResult &&
                        this.state.scaResult.finalStatus === 'success')
                    }
                    className="col col-11 scheduleApptButton btn btn-primary"
                    onClick={
                      this.state.ccHandleMode && this.state.merchant === 'moolah'
                        ? this.handleMoolahSubmit
                        : this.handleSubmit
                    }
                  >
                    {this.renderScheduleButtonLabel()}
                  </ContinueButton>
                </div>
              ) : (
                <ContinueButton
                  id="continueButton"
                  color={this.props.config.color}
                  hover={this.state.hover}
                  disabled={
                    !isEnabled ||
                    this.state.submitting ||
                    this.state.show ||
                    !!this.state.surchargeDisclosure ||
                    this.state.scaInProgress ||
                    (this.state.scaResult &&
                      this.state.scaResult.finalStatus === 'success')
                  }
                  className="col col-11 scheduleApptButton btn btn-primary"
                  onClick={
                    this.state.ccHandleMode && this.state.merchant === 'moolah'
                      ? this.handleMoolahSubmit
                      : this.handleSubmit
                  }
                >
                  {this.renderScheduleButtonLabel()}
                </ContinueButton>
              )}
            </>
          ) : (
            <div className="col col-12 createLoader">
              <Spacer height="10px" />
              <PulseLoader color={'#707070'} size={10} />
            </div>
          )}
        </div>
        <Modal
          onClose={this.showModal}
          show={this.state.show}
          phone={this.state.guarantor ? this.state.guarantor.phone : this.state.phone}
          config={this.props.config}
          sendVerification={this.props.sendVerification}
          checkVerification={this.props.checkVerification}
          verify={this.props.verify}
          t={t}
          verifyingAndScheduling={this.state.verifyingAndScheduling}
        >
          Message in Modal
        </Modal>
        {this.state.showGuarantorModal && (
          <GuarantorModal
            scheduleFor={this.state.scheduleFor}
            guarantor={this.state.guarantor}
            config={{ ...this.props.config, hover: this.state.hover }}
            changeScheduleFor={this.handleScheduleFor}
            closeGuarantorModal={this.handleCloseGuarantorModal}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(ScheduleAppointment);
